import * as Sentry from "@sentry/react";

const SENTRY_DSN = (import.meta.env.VITE_SENTRY_DSN?.trim()) || "https://ed15bde8843632d7c301188cb16a6d31@o4511127400808448.ingest.de.sentry.io/4511127404609616";

let isInitialized = false;

export function initializeSentry() {
  if (isInitialized) return;
  if (import.meta.env.DEV) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.2,
    ignoreErrors: [
      // CSP blocks eval() in GTM/third-party scripts — correctly blocked, not an app error
      /Refused to evaluate a string as JavaScript/,
    ],
  });

  isInitialized = true;
}

export function isSentryEnabled() {
  return !import.meta.env.DEV;
}
